import React, { useState, useEffect } from "react";

import { Link,useNavigate } from 'react-router-dom'

import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import { UniversalImg1, UniversalImg2,EyeCloseIcon, EyeOpenIcon } from "../../Constant/Index";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SignUp = () => {

    const [passwordStates, setPasswordStates] = useState([]);

    const togglePasswordVisibility = (index) => {
        setPasswordStates((prevStates) => {
            const newStates = [...prevStates];
            newStates[index] = !newStates[index];
            return newStates;
        });
    };
    const [userType, setUserType] = useState(true);
  
    const toggleSignup = (newValue) => {
        setUserType(newValue); // Change the state value based on the passed parameter
      };
    const [startDate, setStartDate] = useState("");
    useEffect(() => {
        const inputElement = document.getElementById('myInput');

        const changePlaceholder = () => {
            if (inputElement) {
                inputElement.placeholder = 'Date of Birth';
            }
        };

        const timeoutId = setTimeout(changePlaceholder, 2000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/user/home');
    };
    const handleSubmit1 = (e) => {
        e.preventDefault();
        navigate('/therapist/home');
    };
    return (
        <>
            <Header />
            <UniversalBanner heading="Sign Up" />
            <section className="auth-section">
                <div className="container">
                    <div className="auth-start">
                        <div className="row">
                            <div className="col-md-7 order-1 order-md-0 mt-5 mt-md-0">
                                <div className="row">
                                    <div className="col-xl-1"></div>
                                    <div className="col-xl-10 col-lg-11"  data-aos="fade-left" data-aos-duration="800">
                                        <div className="form-area">
                                            <ul className="sign-up-users">

                                                <li className={`single-method ${(userType) ? ' active' : ''}`}>
                                                    <button onClick={() => toggleSignup(true)} className="button-text">Sign Up as User</button>
                                                </li>

                                                <li className={`single-method ${(userType) ? '' : ' active'}`}>
                                                    <button onClick={() => toggleSignup(false)} className="button-text">Sign Up as Therapist</button>
                                                </li>

                                            </ul>
                                            {(userType) ?
                                                <form onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="First Name" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Last Name" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Enter Email" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Enter Contact" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-4">
                                                            <div className="form-group password">
                                                                <input type={passwordStates[0] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="Password" />
                                                                <button className="show-password" type="button" onClick={() => togglePasswordVisibility(0)}>
                                                                    <img src={passwordStates[0] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-4">
                                                            <div className="form-group password">
                                                                <input type={passwordStates[1] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="Confirm Password" />
                                                                <button className="show-password" type="button" onClick={() => togglePasswordVisibility(1)}>
                                                                    <img src={passwordStates[1] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12 mb-4">
                                                            <div className="form-submit">
                                                                <button type="submit" className="btn d-block px-5">Sign Up</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                                :
                                                <form onSubmit={handleSubmit1}>
                                                    <div className="row">
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="First Name" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Last Name" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Enter Email" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Enter Contact" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-4">
                                                            <div className="form-group password">
                                                                <input type={passwordStates[2] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="Password" />
                                                                <button className="show-password" type="button" onClick={() => togglePasswordVisibility(2)}>
                                                                    <img src={passwordStates[2] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-4">
                                                            <div className="form-group password">
                                                                <input type={passwordStates[3] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="Confirm Password" />
                                                                <button className="show-password" type="button" onClick={() => togglePasswordVisibility(3)}>
                                                                    <img src={passwordStates[3] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                {/* <input type="text" name="" id="" className="form-control" placeholder="Enter Contact" /> */}
                                                                <select name="" id="" className="form-select form-control">
                                                                    <option value="">Gender</option>
                                                                    <option value="Male">Male</option>
                                                                    <option value="Female">Female</option>

                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group position-relative password">
                                                                {/* <input type="text" name="" id="" className="form-control" placeholder="Date OF Birth" /> */}
                                                                <DatePicker selected={startDate}  placeholderText={'Date of Birth'} id="myInput" className="form-control" onChange={(date) => setStartDate(date)} />
                                                                <button className="show-password" type="button">
                                                                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M4.88889 1V3.4M11.1111 1V3.4M1.38889 6.672H14.6111M15 6.2V13C15 15.4 13.8333 17 11.1111 17H4.88889C2.16667 17 1 15.4 1 13V6.2C1 3.8 2.16667 2.2 4.88889 2.2H11.1111C13.8333 2.2 15 3.8 15 6.2Z" stroke="#8A8888" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M10.9927 11H11M10.9927 13H11M7.99676 11H8.00486M7.99676 13H8.00486M5 11H5.0081M5 13H5.0081" stroke="#8A8888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Address" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-3 col-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="State" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-3 col-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="City" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-3 col-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Zip Code" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-3 col-6 mb-3 mb-md-3 mb-lg-4">
                                                            <div className="form-group">
                                                                <input type="text" name="" id="" className="form-control" placeholder="Country" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-4">
                                                            <div className="form-submit">
                                                                <button type="submit" className="btn d-block px-5">Sign Up</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            }
                                            <p className="text auth-option site-main-color">Already have an account? <Link to="/signin" className="mediam-font site-main-color">Sign in</Link></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-5"  data-aos="fade-right" data-aos-duration="800">
                                <figure className="with-bg with-hover">
                                    <img src={(userType) ? UniversalImg1 : UniversalImg2} className="auth-img w-100 with-radius with-boxes" alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </>
    )
}
export default SignUp;